import React, { useRef, useState } from 'react';
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';

function Map({ position = { lat: 51.505, lng: -0.09 } }) {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script-main',
    googleMapsApiKey: googleMapsApiKey,
  });

  const [markers] = useState([{ position: position, label: ' ' }]);
  const mapRef = useRef(null);
  const [currentLocation, setCurrentLocation] = useState(position);

  return isLoaded && currentLocation?.lat && currentLocation?.lng ? (
    <GoogleMap
      id="google-map-script-main"
      ref={mapRef}
      mapContainerStyle={containerStyle}
      center={{
        lat: currentLocation?.lat,
        lng: currentLocation?.lng,
      }}
      zoom={10}
      options={{
        disableDefaultUI: true,
        gestureHandling: null,
        mapTypeControl: true,
        mapTypeId: 'terrain',
        streetViewControl: false,
        mapTypeControl: false,
        zoomControl: true,
        styles: [
          {
            featureType: 'all',
            elementType: 'labels',
            stylers: [
              {
                visibility: 'off',
              },
            ],
          },
          {
            featureType: 'administrative',
            elementType: 'labels',
            stylers: [
              {
                visibility: 'on',
              },
            ],
          },
          {
            featureType: 'road',
            elementType: 'labels',
            stylers: [
              {
                visibility: 'on',
              },
            ],
          },
        ],
      }}
    >
      {/* Child components, such as markers, info windows, etc. */}

      {markers &&
        Array.isArray(markers) &&
        markers.map((marker, index) => (
          <Marker
            options={{ anchorPoint: 'bottom' }}
            key={index}
            position={marker.position}
            zIndex={index + 1}
          ></Marker>
        ))}
    </GoogleMap>
  ) : (
    <></>
  );
}

export default React.memo(Map);

const containerStyle = {
  width: '100%',
  minHeight: '400px',
  height: '100%',
};

const googleMapsApiKey = 'AIzaSyBn_AmdekbA79CHvrv2O1IdDxoHcbJY0jk';

//const googleMapsApiKeyFromSandBox = "AIzaSyAwcOSQ6hnqoqiXX_1D1ykHOBAZZ2UorHE";
//https://codesandbox.io/p/sandbox/react-places-autocomplete-03vef?file=%2Fpublic%2Findex.html%3A25%2C5-25%2C129
